import { gql, useQuery } from '@apollo/client'

import agentClient from '@/lib/apollo/client/agent'
import type { WrappedUseQuery } from '@/lib/apollo/types'
import type { Application } from '@/types/Activity'

const searchForApplicationsQuery = gql`
  query ($customerId: String!, $query: String!, $limit: Int, $offset: Int) {
    searchForApplications(
      customerId: $customerId
      query: $query
      limit: $limit
      offset: $offset
    ) {
      total
      offset
      limit
      results {
        customerClientName
        applicationId
        customerId
        subjectId
        timestamp
        outcome {
          status
          comments
        }
        context {
          journeyType
        }
        referenceTier
        attachedSubjects {
          name
          avatar
          customerId
          applicationId
          subjectId
          email
          type
          outcome {
            status
            comments
          }
          context {
            journeyType
          }
          referenceTier
        }
        additionalTenants {
          name
          avatar
          customerId
          applicationId
          subjectId
          email
          type
          outcome {
            status
            comments
          }
          context {
            journeyType
          }
          referenceTier
          attachedSubjects {
            name
            avatar
            customerId
            applicationId
            subjectId
            email
            type
            outcome {
              status
              comments
            }
            context {
              journeyType
            }
            referenceTier
          }
        }
        assets {
          price
          attributes {
            address {
              nameOrNumber
              line1
              line2
              city
              country
              postcode
            }
          }
        }
        context {
          results {
            name
            outcome
            properties {
              name
              supportingData
              dataMatches
              decisionInfo
              result
            }
          }
          firstName
          lastName
          middleName
          email
          mobile
          dob
          nationality
          documents {
            fileName
            thumbnail
            specifiedType
            id
          }
          journeyType
        }
        title
        reportUrl
        avatar
        updatedAt
        itemAndValues {
          value
        }
      }
    }
  }
`

export type SearchForApplicationData = {
  searchForApplications: {
    total: number
    results: Application[]
    limit: number
    offset: number
  }
}

type QueryVars = {
  customerId: string
  query: string
  limit: number
  offset: number
}

export const useSearchForApplicationsQuery: WrappedUseQuery<
  SearchForApplicationData,
  QueryVars
> = options =>
  useQuery<SearchForApplicationData, QueryVars>(searchForApplicationsQuery, {
    ...options,
    client: agentClient,
  })
